module.exports = __webpack_public_path__ + "img/trousers_2.05e5f3bb.png";